module.exports = __webpack_public_path__ + "media/images/check-9dc6c3bd4b6b17ced8d39e1b74ef86c9.svg";